import { useHistory } from "react-router-dom";

function useBeforeFirstRender(client){
  const history = useHistory();
  if(!client) history.push('/cotizaciones');
}

export default useBeforeFirstRender;